var render, staticRenderFns
import script from "./AlertChip.vue?vue&type=script&lang=js&"
export * from "./AlertChip.vue?vue&type=script&lang=js&"
import style0 from "./AlertChip.vue?vue&type=style&index=0&id=7f1925b3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1925b3",
  null
  
)

export default component.exports